module.exports = __webpack_public_path__ + "static/media/file.699fb665.svg";